module.exports = __webpack_public_path__ + "img/icon4.d3c1b7d5.gif";